import { render, staticRenderFns } from "./cTabs.vue?vue&type=template&id=38890b5f&scoped=true&"
import script from "./cTabs.vue?vue&type=script&lang=ts&"
export * from "./cTabs.vue?vue&type=script&lang=ts&"
import style0 from "./cTabs.vue?vue&type=style&index=0&id=38890b5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38890b5f",
  null
  
)

export default component.exports